import React, { memo, useRef } from "react";
import { Box } from "@mui/material";
import { GoogleMap, OverlayView } from "@react-google-maps/api";
import { LocationOn } from "@mui/icons-material";
import { useGoogleMaps } from "../../../../Contexts/GoogleMapsContext";
const mapContainerStyle = {
  width: "100%",
  height: "200px",
};

// Custom marker using OverlayView to avoid deprecated google.maps.Marker
const CustomMarker = ({ position }: { position: google.maps.LatLngLiteral }) => {
  return (
    <OverlayView
      position={position}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
    >
      <Box
        sx={{
          transform: "translate(-50%, -100%)",
          cursor: "pointer",
        }}
      >
        <LocationOn
          sx={{
            fontSize: 40,
            color: "#D32F2F",
            filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.3))",
          }}
        />
      </Box>
    </OverlayView>
  );
};

type MapViewProps = {
  latitude?: any;
  longitude?: any;
};
const MapView = memo((props: MapViewProps) => {
  const mapOptions = {
    streetViewControl: true, // Enable Street View pegman control
    disableDefaultUI: true, // Disable all default UI controls
    zoomControl: false, // Disable zoom control
    mapTypeControl: false, // Disable map type control (satellite toggle)
    minZoom: 15, // Allow more zoom out (3 is a good default for continent-level view)
    maxZoom: 17, // Keep the max zoom to street level (default max is 21)
  };

  const { isLoaded, loadError } = useGoogleMaps();

  const mapRef = useRef<google.maps.Map | null>(null);
  const center = {
    lat: parseFloat(props.latitude), // Latitude of the center location
    lng: parseFloat(props.longitude), // Longitude of the center location
  };

  const onMapLoad = (map: any) => {
    mapRef.current = map;
    // Street View is already enabled via streetViewControl option
  };

  if (loadError) return <div>Error loading maps</div>;
  if (!isLoaded) return <div>Loading Maps...</div>;

  return (
    <Box borderRadius={2} overflow={"hidden"} border="2px solid #e1e1e1">
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        zoom={14}
        center={center}
        onLoad={onMapLoad}
        options={mapOptions}
      >
        <CustomMarker position={center} />
      </GoogleMap>
    </Box>
  );
});

export default MapView;
